import {
  LOAD_QUESTIONS,
  SUBMIT_ANSWER,
  NEXT_QUESTION,
  PREVIOUS_QUESTION,
  DECREMENT_TIMER,
  END_ASSESSMENT,
  RESET_QUIZ,
  Start_ASSESSMENT,
} from "../action/quizAction";

const initialState = {
  questions: [],
  assessmentTimeLeft: 0,
  currentQuestionIndex: 0,
  answers: {}, // { questionIndex: answer }
  isAssessmentEnded: false,
  starttest: false,
  elapsedSeconds: 0,
};

export default function quizReducer(state = initialState, action) {
   console.log("action",action.type)
  switch (action.type) {
    case LOAD_QUESTIONS:
      return {
        ...state,
        questions: action.payload.questions,
        assessmentTimeLeft:
          state.assessmentTimeLeft > 0
            ? state.assessmentTimeLeft
            : action.payload.assessmentTime * 60, // convert minutes to seconds here
        currentQuestionIndex: 0,
        answers: {},
        isAssessmentEnded: false,
      };
    case SUBMIT_ANSWER:
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.payload.questionIndex]: action.payload.answer,
        },
      };
    case NEXT_QUESTION:
      return {
        ...state,
        currentQuestionIndex: Math.min(
          state.currentQuestionIndex + 1,
          state.questions.length - 1
        ),
      };
    case PREVIOUS_QUESTION:
      return {
        ...state,
        currentQuestionIndex: Math.max(state.currentQuestionIndex - 1, 0),
      };
    case DECREMENT_TIMER:
      return {
        ...state,
        assessmentTimeLeft: Math.max(state.assessmentTimeLeft - 1, 0),
      };
    case END_ASSESSMENT:
      return {
        ...state,
        isAssessmentEnded: true,
      };
    case Start_ASSESSMENT:
      return {
        ...state,
        starttest: action.payload,
      };
    case RESET_QUIZ:
      return {
    ...initialState,
  };
    default:
      return state;
  }
}
